import { render, staticRenderFns } from "./CatalogSourceList.vue?vue&type=template&id=85b3320a"
import script from "./CatalogSourceList.vue?vue&type=script&lang=ts"
export * from "./CatalogSourceList.vue?vue&type=script&lang=ts"
import style0 from "./CatalogSourceList.vue?vue&type=style&index=0&id=85b3320a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports